export default {
  LOGOUT: 'app/LOGOUT',
  CONNECT: 'app/CONNECT',
  NO_GOLF: 'app/NO_GOLF',
  SET_USER: 'app/SET_USER',
  LOAD_GOLF: 'app/LOAD_GOLF',
  NO_ACCOUNT: 'app/NO_ACCOUNT',
  LOAD_ACCOUNT: 'app/LOAD_ACCOUNT',
  LOGIN_FAILED: 'app/LOGIN_FAILED',
  LOGIN_SUCCESS: 'app/LOGIN_SUCCESS',
  UPDATE_ACCOUNT: 'app/UPDATE_ACCOUNT',
  TOGGLE_PANEL_NAV: 'app/TOGGLE_PANEL_NAV',
  GET_GOLF_WEATHER: 'app/GET_GOLF_WEATHER',
  LOAD_ACTIVATION_DATA: 'app/LOAD_ACTIVATION_DATA',
  GET_GOLF_GAME_CONDITIONS: 'app/GET_GOLF_GAME_CONDITIONS',
  gql: {
    GET_GOLF: `
      query($id: String!) {
        getGolf(id: $id) {
          id
          name
          city
          postalCode
          email
          phone
          slug
          latitude
          longitude
          storeAppVersion
          ios
          android
          reference
          options {
            name
            value
          }
          network
          locale
          currency
          applicationId
          appEnabled
          pushEngine
        }
      }
    `,
    GET_ACCOUNT: `
      query {
        getAccount {
          id
          firstname
          lastname
          email
          phone
          covidCertificate
          ffg {
            license
            handicap
            handicapDate
          }
          matches {
            golfId
            reference
            isMember
            isFavorite
          }
        }
        getAccountPlayerTypes {
          golfId
          id
          name
          rules {
            name
            value
          }
        }
      }
    `,
    GET_MATCH_ACCOUNT: `
      query($code: String!) {
        getMatchAccount(code: $code) {
          golf {
            id
            name
          }
          reference
          firstname
          lastname
          phone
          email
        }
      }
    `,
    SET_ACCOUNT: `
      mutation(
        $email: String!
        $firstname: String!
        $lastname: String!
        $phone: String!
        $license: String
        $activationData: ActivationData
      ) {
        setAccount(
          email: $email
          firstname: $firstname
          lastname: $lastname
          phone: $phone
          license: $license
          activationData: $activationData
        ) {
          id
          firstname
          lastname
          email
          phone
          ffg {
            license
            handicap
            handicapDate
          }
          matches {
            golfId
            reference
            isMember
            isFavorite
          }
        }
      }
    `,
    CHANGE_PASSWORD: `
      mutation(
        $password: String!
        $passwordConfirm: String!
      ) {
        changePassword(
          password: $password
          passwordConfirm: $passwordConfirm
        ) {
          success
        }
      }
    `,
    CHANGE_LOGIN: `
      mutation($email: String!) {
        changeLogin(email: $email) {
          success
        }
      }
    `,
    SET_USER_OPTION: `
      mutation($option: UserOption!) {
        setUserOption(option: $option) {
          success
        }
      }
    `,
    GET_GOLF_GAME_CONDITIONS: `
      query($id: String!) {
        getGolfGameConditions(id: $id) {
          type
          name
          label
          status
          comment
          statuses {
            status
            label
          }
        }
      }
    `,
    GET_GOLF_WEATHER: `
      query($id: String!) {
        getGolfWeather(id: $id) {
          temp
          min
          max
          humidity
          wind
          direction
          main
          weather
          icon
        }
      }
    `,
    GET_GOLF_INTERESTS: `
      query($id: String!) {
        getGolfInterests(id: $id) {
          id
          name
        }
      }
    `,
    GET_GOLF_RECIPROCIIES: `
      query($id: String!) {
        getGolfReciprocities(id: $id) {
          mailTo
          golfs {
            name
            dates
          }
        }
      }
    `,
  },
};
